import { render, staticRenderFns } from "./HotScriptsDetail.vue?vue&type=template&id=cb1acf5a&scoped=true"
import script from "./HotScriptsDetail.vue?vue&type=script&lang=js"
export * from "./HotScriptsDetail.vue?vue&type=script&lang=js"
import style0 from "./HotScriptsDetail.vue?vue&type=style&index=0&id=cb1acf5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1acf5a",
  null
  
)

export default component.exports